
<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="formaPago"></p-toast>
<p-confirmDialog [transitionOptions]="'0ms'" key="confirmarFormaPago" title="Confirmar Acción"
                 appendTo="body"></p-confirmDialog>
<div class="p-grid" style="width: 99%">
  <div class="p-col-12">
    <app-invmaebarra [botonNuevo]="btnNuevo" [botonGuardar]="btnGuardar" [botonBorrar]="btnBorrar"
                     [botonRegresar]="btnRegresar" [barraBotonesCRUD]="false"
                     [barraBotonesDesplaz]="true" [barraBotones3]="true" [barraBotonesAsiCon]="true" [barraBotones5]="true"
                     (signal)="manejarSenales($event)"></app-invmaebarra>
  </div>
  <div style="overflow: hidden" class="p-col-12">
    <p-tabView>
      <p-tabPanel header="Formas de Pago">
        <app-aggridsaci [width]=""
                        [height]="largo"
                        [enableSorting]="false"
                        [enableFilter]="true"
                        [rowData]="formapagosService.formaPagoServicio"
                        [frameworkComponents]="frameworkComponents"
                        [animateRows]="true"
                        [rowSelection]="rowSelection"
                        [columnDefs]="columnDefsCxcformaPago"
                        [defaultColDef]="defaultColDefCxcformaPago"
                        [rowStyle]="rowStyle"
                        [singleClickEdit]="false"
                        [botones]="false"
						(guardarEnter)="controlGuardar($event)"
                        (selected)="seleccionFormaPago($event)"
                        (cambios)="cambio($event)"

        ></app-aggridsaci>
      </p-tabPanel>
    </p-tabView>
  </div>


</div>

